var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBathroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_596_1641)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.40061 9.17698H2.60061C1.4981 9.17698 0.600586 8.27947 0.600586 7.17695V5.37695H9.40056V7.17695C9.40056 8.27947 8.50305 9.17698 7.40061 9.17698ZM1.00056 5.77693V7.17695C1.00056 8.05945 1.71812 8.77693 2.60061 8.77693H7.40061C8.2831 8.77693 9.00059 8.05945 9.00059 7.17695V5.77693H1.00056Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00098 8.97656H3.40095V9.57656H3.00098V8.97656Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60059 8.97656H7.00056V9.57656H6.60059V8.97656Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20076 5.5762H1.80078V1.9762C1.80078 1.20364 2.42825 0.576172 3.20081 0.576172C3.97329 0.576172 4.60076 1.20364 4.60076 1.9762V2.17615H4.20078V1.9762C4.20078 1.42366 3.75327 0.976147 3.20081 0.976147C2.64827 0.976147 2.20076 1.42366 2.20076 1.9762V5.5762Z",
    fill: "#1996A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80095 3.77656H3.00098V3.37651C3.00098 2.60403 3.62844 1.97656 4.401 1.97656C5.17349 1.97656 5.80095 2.60403 5.80095 3.37651V3.77656ZM3.40095 3.37651H5.40098C5.40098 2.82405 4.95347 2.37654 4.401 2.37654C3.84846 2.37654 3.40095 2.82405 3.40095 3.37651Z",
    fill: "#1996A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_596_1641"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(0.506836 0.576172)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathroom);
export default __webpack_public_path__ + "static/media/bathroom.ffb9a876aae090e47ab6da4eb6c0d04b.svg";
export { ForwardRef as ReactComponent };